import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../stateProvider/StateProvider';
import { QuestRoute } from '../api/QuestRoutes';
import { createNewUser, formatCurrency } from '../utility/functions';
import GetState from '../GetState';
import Form from '../forms/Form';
import Radio from '../forms/Radio';
import Input from '../forms/Input';
import Select from '../forms/Select';
import { HSOptions } from '../../constants/HSOptions';
import EmailInput from '../forms/formComponents/EmailInput';
import Checkbox from '../forms/Checkbox';
import HamQuest from '../api/HamQuestGiver';
import { addCardToAccount } from '../PaymentForm';
import AutoSelectAndUpgrade from '../forms/formComponents/AutoSelectAndUpgrade';
import ModalFactory from '../Modal';
import Button from '../forms/Button';
import PhoneNumberInput from '../forms/formComponents/PhoneNumberInput';
import { isDev } from '../../constants/config';

const ExpressPassForm = ({ parent, billingCycle, refresh, ...props }) => {
    const {
        state: {
            states         
        },
    } = useGlobalState();

    // const [expressPassTypes] = GetState(QuestRoute.expressPass.types);

    // const [expressPassAward] = GetState(QuestRoute.expressPass.awards, { loading: [] });

    const [expressPassSettings] = GetState(QuestRoute.expressPass.settings);
    const [type, setType] = useState('');
    const [signupAwards, setSignupAwards] = useState([]);

    useEffect(() => {
        if (!type) return;
        HamQuest.getQuery(QuestRoute.expressPass.signupAwards, {
            loyaltyType: type,
            loyaltyAccountId: parent
        })
            .then(res => setSignupAwards(res.map((e) => ({ ...e, label: `${e.label} (${formatCurrency(e.price)})` }))))
    }, [type])

    const types = {
        LP: 'LicensePlate',
        RF: 'RFID',
        App: 'AppId',
    };

    // const passMaxUses = [{ label: context.user.passMaxUsePeriod, value: context.user.passMaxUsePeriod }, ...HSOptions.expressPass.maxUsePeriod];
    // const receiptMode = [{ label: context.user.receiptMode, value: context.user.receiptMode }, ...HSOptions.expressPass.receiptMode];

    const commonUserData = {
        expressType: '',
        package: '',
        mediaType: 'RFID',
        tagType: '',
        mediaId: '',
        mediaStatus: 'Active',
        firstName: '',
        lastName: '',
        cellPhoneNumber: '',
        address1: '',
        address2: '',
        city: '',
        zipPostalCode: '',
        state: '',
        customPrice: '',
        passMaxUsePeriod: '',
        passReuseInhibitTime: '',
        accountStatus: 'Active',
        billingType: '',
        useCash: false,
        autoSelect: '',
        emailInvoice: true,
        useContactEmail: true,
        useDefaultPassReuseTime: true,
        allowUpgrades: '',
        receiptMode: ''
    };

    const [userInputs] = useState(isDev ? { ...commonUserData, ...createNewUser() } : { ...commonUserData });

    return (
        <Form
            name='addExpressPassUser'
            inputs={userInputs}
            onSubmit={e => (
                HamQuest.post(QuestRoute.expressPass.users, {
                    ...e,
                    parent: parent
                })
                    .then(async res => {
                        const priceCharged = e.expressType === 'PrepaidPass' ? (e.customPrice || signupAwards.find(f => f.value === e.package)?.price) ?? 0 : false;
                        if (!parent) {
                            if (e.useCash) {
                                ModalFactory.update({
                                    id: props.id,
                                    title: 'Success',
                                    body: `User created successfully.`,
                                    type: 'success',
                                    buttons: [<Button loyaltyAccountId={res.loyaltyAccountId} onClick={() => ModalFactory.close(props.id)}>To User</Button>],
                                })
                            } else {
                                await addCardToAccount(res.customerId)
                                    .then(() => {
                                        HamQuest.get(QuestRoute.expressPass.completeSignup(res.customerId))
                                            .then(() => {
                                                ModalFactory.update({
                                                    id: props.id,
                                                    title: 'Success',
                                                    body: `User created successfully and card charged ${formatCurrency(priceCharged)}`,
                                                    type: 'success',
                                                    buttons: [<Button loyaltyAccountId={res.loyaltyAccountId} onClick={() => ModalFactory.close(props.id)}>To User</Button>],
                                                })
                                            })
                                            .catch(ModalFactory.catch)
                                    })
                                    .catch(ex => (
                                        ModalFactory.update({
                                            id: props.id,
                                            title: 'Oops',
                                            body: `User created successfully but failed to add a card to the account`,
                                            type: 'error',
                                            buttons: [<Button loyaltyAccountId={res.loyaltyAccountId} onClick={() => ModalFactory.close(props.id)}>To User</Button>],
                                        })
                                    ))
                            }
                        } else {
                            ModalFactory.update({
                                id: props.id,
                                title: 'Success',
                                body: `Member created successfully`,
                                type: 'success'
                            })
                        }

                        if (refresh) {
                            refresh();
                        }
                    })
            )}
        >
            {({ values }) => (
                <>
                    <Radio
                        label='Select Loyalty Type'
                        name='expressType'
                        getOptions={parent ? QuestRoute.expressPass.allowedTypes(parent) : QuestRoute.expressPass.types}
                        callback={res => setType(res)}
                        required
                    />
                    <Radio
                        label='Select Package'
                        name='package'
                        options={signupAwards}
                        required
                    />
                    {/* <Select
                        name='mediaType'
                        label='Media Type'
                        options={[{
                            label: 'RFID',
                            value: 'RFID'
                        }]}
                        required
                    /> */}
                    <Input
                        label='Media Type'
                        value='RFID'
                        disable={true}
                    />
                    <input type='hidden' name='mediaType'/>
                    <Select
                        name='tagType'
                        label='Tag Type'
                        options={HSOptions.user.media.tags}
                        required
                    />
                    <Input
                        name='mediaId'
                        label='Media ID'
                        maxLength={100}
                        sanitize={e => e.replace(/\D/g, '')}
                        validate={(e, setMsg, resolve) => {
                            const inputMediaId = e;
                            if (e) {
                                HamQuest.post(QuestRoute.validate.mediaID, {
                                mediaId: e,
                                tagType: values.tagType
                            })
                             .then(res => {
                            if (!res) setMsg('Media ID is already associated with an account.');
                            resolve(!res)
                        })
                        .catch((ex) => {
                            setMsg(ex.blob);
                        })
                } else {
                    setMsg('Please enter a valid Media ID.');
                    resolve(true)
                }
            }}
                        required
                    />

                    {/* <Select
                        label='Media Status'
                        name='mediaStatus'
                        options={HSOptions.expressPass.status}
                        required
                    /> */}

                    <EmailInput />
                    <Input
                        label='Confirm Email'
                        name='confirmEmail'
                        type='email'
                        confirmation='email'
                        required
                    />
                    <Checkbox
                        label='Email Invoice'
                        name='emailInvoice'
                    />
                    <Checkbox
                        label='Use Contact Email'
                        name='useContactEmail'
                    />
                    <Input
                        label='First Name'
                        name='firstName'
                        required
                    />
                    <Input
                        label='Last Name'
                        name='lastName'
                        required
                    />
                    <PhoneNumberInput
                        name='cellPhoneNumber'
                    />
                    <Input
                        label='Address 1'
                        name='address1'
                        required
                    />
                    <Input
                        label='Address 2'
                        name='address2'
                    />
                    <Input
                        label='City'
                        name='city'
                        required
                    />
                    <Input
                        label='Postal Code'
                        name='zipPostalCode'
                        required
                    />
                    <Select
                        label='State'
                        name='state'
                        options={states}
                        required
                    />
                    <Checkbox
                        label='Use Cash on signup'
                        name='useCash'
                    />
                    <Checkbox
                        label='Use Custom Price'
                        name='useCustomPrice'
                    />
                    <Input
                        label='Custom Price'
                        name='customPrice'
                        type='price'
                        disable={!values.useCustomPrice}
                    />
                    <Select
                        label='Max Use Period'
                        name='passMaxUsePeriod'
                        value={expressPassSettings?.passMaxUsePeriod}
                        options={HSOptions.expressPass.maxUsePeriod}
                        required

                    />
                    <Input
                        label='Pass Max Uses'
                        name='passMaxUses'
                        disable={values.passMaxUsePeriod === 'Unlimited'}
                        type='number'
                    />
                    <Checkbox
                        label='Use Default Pass Reuse Time'
                        name='useDefaultPassReuseTime'
                    />
                    <Input
                        label='Pass Reuse Inhibit Time (min)'
                        name='passReuseInhibitTime'
                        type='numbers'
                        disable={values.useDefaultPassReuseTime}
                    />
                    <Select
                        label='Account Status'
                        name='accountStatus'
                        options={HSOptions.washClub.status}
                        required
                    />
                    <Select
                        label='Billing Type'
                        name='billingType'
                        options={HSOptions.user.recurringBilling}
                        required
                    />
                    <Select
                        label='Receipt Mode'
                        name='receiptMode'
                        options={HSOptions.expressPass.receiptMode}
                        required
                    />
                    <AutoSelectAndUpgrade />
                </>
            )}

        </Form>
    );
}

export default ExpressPassForm;